import { render } from "./register-2.vue?vue&type=template&id=5d3fa1fc"
import script from "./register-2.vue?vue&type=script&lang=js"
export * from "./register-2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__